import ReactImageFallback from 'react-image-fallback';
import PlaceholderImage from '../../../../../assets/images/placeholders/images/product_image_loading_fallback.png';

export const ProductCard = ({ imageUrl, catalogName, productName }) => (
  <div className="w-100 d-flex gap-2 align-items-center">
    <ReactImageFallback
      src={imageUrl}
      fallbackImage={PlaceholderImage}
      initialImage={PlaceholderImage}
      alt="Tagged product"
      className="h-50px w-50px"
    />

    <div className="d-flex flex-column">
      <span>{productName}</span>
      <span className="text-muted small">{catalogName} </span>
    </div>
  </div>
);
